<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Версия</label>
            <crm-input-text
              [(value)]="form.version"
              placeholder="1.0.0"
              [isError]="$any(errors?.version)"></crm-input-text>
            <small
              *ngIf="errors?.version"
              class="p-error">
              {{ errors.version | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Changelog</label>
            <crm-editor
              [(value)]="form.changelog"
              height="110px"></crm-editor>
            <small
              *ngIf="errors?.changelog"
              class="p-error">
              {{ errors.changelog | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Файл</label>
            <p
              *ngIf="form?.file?.name"
              class="mb-1">
              {{ form.file.name }}
            </p>
            <crm-file-uploader
              label="Загрузить"
              (filesUploaded)="setFile($event)"></crm-file-uploader>
            <small
              *ngIf="errors?.file"
              class="p-error">
              {{ errors.file | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveExtension()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
